import { useMemo } from 'react'
import { formatDistanceToNow } from 'date-fns'
import { enUS, de, pl, arSA } from 'date-fns/locale'

import { useTranslation } from 'next-i18next'

import { getNavigationIcon } from '@/constants/navigationAssets'

import { useMarket } from '@/utils/multi-markets/context'

import { LastBookedContainer } from '../ParkingTile.styled'

interface LastBookingProps {
  value: string
}

const localeMap: Record<string, Locale> = {
  en: enUS,
  de: de,
  pl: pl,
  ar: arSA
}

const LastBooking: React.FC<LastBookingProps> = ({ value }) => {
  const { t } = useTranslation('parkings')
  const { locale } = useMarket()

  const dateFnsLocale = localeMap[locale.split('-')[0]] || enUS

  const formattedDifference = useMemo(() => {
    const bookingDate = new Date(value)
    const now = new Date()
    const oneDayInMs = 24 * 60 * 60 * 1000

    if (now.getTime() - bookingDate.getTime() > oneDayInMs) {
      return null
    }

    return formatDistanceToNow(bookingDate, {
      addSuffix: true,
      locale: dateFnsLocale
    })
  }, [value, dateFnsLocale])

  return formattedDifference ? (
    <LastBookedContainer>
      <img src={getNavigationIcon('clockDashed')} alt="clock icon" />
      {`${t('lastBooked')} ${formattedDifference}`}
    </LastBookedContainer>
  ) : null
}

export default LastBooking
